import * as React from 'react';
import type { SVGProps } from 'react';

const LocationTargetSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon/LocationTarget">
      <g id="Icon">
        <path d="M8 10.0001C9.10457 10.0001 10 9.10469 10 8.00012C10 6.89555 9.10457 6.00012 8 6.00012C6.89543 6.00012 6 6.89555 6 8.00012C6 9.10469 6.89543 10.0001 8 10.0001Z" fill="#616061"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M2.08296 7.00012C2.50448 4.48762 4.48749 2.5046 7 2.08308V0.00012207H9V2.08308C11.5125 2.5046 13.4955 4.48762 13.917 7.00012H16V9.00012H13.917C13.4955 11.5126 11.5125 13.4956 9 13.9172V16.0001H7V13.9172C4.48749 13.4956 2.50448 11.5126 2.08296 9.00012H0V7.00012H2.08296ZM4 8.00012C4 5.79098 5.79086 4.00012 8 4.00012C10.2091 4.00012 12 5.79098 12 8.00012C12 10.2093 10.2091 12.0001 8 12.0001C5.79086 12.0001 4 10.2093 4 8.00012Z" fill="#616061"/>
      </g>
    </g>
  </svg>
);

export default LocationTargetSvg;